<template>
  <section>
    <ul class="settings-list">
      <li
        v-for="item in list"
        :key="item.url.name"
        class="settings-item"
      >
        <component
          :is="is(item)"
          v-bind="bind(item)"
        >
          <span class="settings-icon">
            <img
              :src="item.icon"
              :alt="item.title"
              width="30"
            >
          </span>

          <span class="settings-info">
            <h3 class="app-h3">
              {{ item.title }}
            </h3>

            <h4 class="app-h4">
              {{ item.description }}
            </h4>
          </span>

          <font-awesome-icon
            v-if="external"
            icon="chevron-right"
            class="settings-arrow"
          />
        </component>
      </li>
    </ul>

    <state-messages
      v-if="!list.length"
      key="settings-list-empty"
      state="empty"
    >
      <template v-slot:empty>
        Você não possui permissão para acessar esta página
      </template>
    </state-messages>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import StateMessages from '@/components/State/Messages.vue';

  const EXTERNAL_REGEX = /^https?:\/\//;

  export default {
    name: 'SettingsList',
    components: {
      StateMessages,
    },
    props: {
      items: {
        type: Array,
        default() {
          return [];
        },
      },
      external: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapState([
        'auth',
      ]),

      user() {
        return this.auth.user;
      },

      list() {
        const {
          id,
          role,
        } = this.user;

        return id
          ? this.items
            .filter(item => item.permissions.indexOf(role.identifier) > -1)
            .filter(item => (item.features && item.features.length
              ? item.features.some(feature => this.user.features.includes(feature))
              : true))
          : [];
      },
    },
    methods: {
      is(item) {
        return EXTERNAL_REGEX.test(item.url) ? 'a' : 'router-link';
      },
      bind(item) {
        const link = EXTERNAL_REGEX.test(item.url);

        return {
          class: 'settings-link',
          [link ? 'href' : 'to']: item.url,
          target: link ? '_blank' : null,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .settings-list {
    list-style: none;
  }

  .settings-item {
    & + & {
      border-top: 1px solid $gray-dark;
    }

    &:hover {
      background-color: $gray-dark;
    }
  }

  .settings-link {
    cursor: pointer;
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: $gutter var(--product--pwa--horizontal);

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter-big var(--product--pwa--horizontal);
    }
  }

  .settings-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border: $gutter-smallest solid $gray-light;
    background-color: $white;
    border-radius: 50%;
    height: $button;
    width: $button;
  }

  .settings-info {
    flex: 1;
    margin: 0 $gutter;
  }

  .settings-arrow {
    font-size: $font-big;
  }
</style>
